import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dialogTitle]',
  standalone: true
})
export class DialogTitleDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
